module.exports = __webpack_public_path__ + "img/fruits-sticker.76260b65.svg";